import { Button } from "@components/atoms/Button"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Themed } from "@components/atoms/Themed"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks, usePostTitleEditor } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Page Header Marketing",
  icon: "block-default",
  tags: ["#page"],
  conditions: {
    postTypes: ["page", "seo-landing"],
  },
}

export default defineBlock("content/page-header-marketing", (props) => {
  const theme = props.page?.pageTheme || props.seoLanding?.pageTheme || "none"

  return (
    <Themed theme={theme} className={cn("flex py-10 themed-fg relative")}>
      {/* Background color */}
      <div className="absolute inset-0 -z-10 themed-bg" data-transition="fade"></div>
      <div className="w-grid mx-auto pt-7">
        <div className="w-full grid grid-cols-1 md:grid-cols-2">
          <div
            className="w-full aspect-square rounded-xl overflow-hidden md:order-1 order-2 themed-bg"
            data-transition="scale"
          >
            {env.admin && !props.featuredImages?.[0]?.mediaItemUrl && (
              <div className="w-full h-full bg-grey flex items-center justify-center type-ui">Select media</div>
            )}
            {props.featuredImages?.[0]?.mediaItemUrl && (
              <ResponsiveImage {...props.featuredImages[0]} className="w-full h-full" objectFit="cover" fadeOnLoad />
            )}
          </div>
          <div
            className="w-full self-stretch grid grid-rows-2 grid-cols-1 justify-center items-start md:order-2"
            data-transition="scale"
          >
            <div
              className="flex h-full flex-col justify-center gap-4 rounded-xl border-2 border-current p-7"
              data-transition="children/fade-up"
            >
              <p className="type-label-s-caps">
                <EditableText as="span" store="eyebrow" placeholder="Enter an optional subheading" />
              </p>
              <h1 className="type-title-m md:type-title-l text-balance">
                {/* {env.admin ? (
                <EditableText as="span" store={usePostTitleEditor()} className="" placeholder="Enter a title" />
              ) : (
                props.page?.title
              )} */}
                <EditableText
                  as="span"
                  store="title"
                  className=""
                  placeholder="Enter a title"
                  defaultValue={props.page?.title || props.seoLanding?.title}
                />
              </h1>
            </div>
            <div className="w-full h-full relative" data-transition="scale">
              <div
                className="absolute left-0 -top-[2px] w-full h-[calc(100%+2px)] grid grid-cols-3"
                data-transition="children/fade-up"
              >
                <div className="flex h-full flex-col justify-center gap-4 rounded-xl border-2 border-current p-7 col-span-2">
                  <EditableText
                    as="h2"
                    store="subtitle"
                    className="type-body-xl md:type-title-s w-full text-balance"
                    placeholder="Enter a subtitle"
                  />
                </div>
                <div className="w-full h-full relative">
                  <div className="absolute -left-[2px] top-0 w-[calc(100%+2px)] h-full p-7 flex items-center justify-center border-2 border-current rounded-full"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Themed>
  )
})
